/* eslint-disable react/prop-types */
import {
  Col,
  DatePicker,
  Form,
  Input,
  Row,
} from 'antd';
import NumericInput from 'components/NumericInput';
import React from 'react';
import { DATE_FRONTEND_FORMAT } from 'utils/formatValues';

const FormCargo = ({ formCargo }) => (
  <Form
    layout="vertical"
    name="cargo"
    form={formCargo}
    className="without-feedback"
  >
    <Row gutter={10}>
      <Col xs={24} sm={24} md={8}>
        <Form.Item name="descripcion" label="Descripción">
          <Input disabled />
        </Form.Item>
      </Col>
      <Col xs={24} sm={24} md={8}>
        <NumericInput
          name="importe"
          label="Importe base"
          decimal
          disabled
        />
      </Col>
      <Col xs={24} sm={24} md={8}>
        <NumericInput
          name="recargo_total"
          label="Recargo"
          currency
          disabled
          decimal
        />
      </Col>
      <Col xs={24} sm={24} md={8}>
        <NumericInput
          name="descuento_total_aplicado"
          label="Descuento"
          currency
          disabled
          decimal
        />
      </Col>
      <Col xs={24} sm={24} md={8}>
        <NumericInput
          name="actualizacion_total"
          label="Actualización"
          currency
          disabled
          decimal
        />
      </Col>
      <Col xs={24} sm={24} md={8}>
        <NumericInput
          name="gasto_total"
          label="Gasto total"
          currency
          disabled
          decimal
        />
      </Col>
      <Col xs={24} sm={24} md={8}>
        <NumericInput
          name="importe_total"
          label="Importe total"
          currency
          disabled
          decimal
        />
      </Col>
      <Col xs={24} sm={24} md={8}>
        <Form.Item name="periodo_fiscal" label="Periodo">
          <Input disabled />
        </Form.Item>
      </Col>
      <Col xs={24} sm={24} md={8}>
        <Form.Item name="fecha_de_vencimiento" label="Fecha de vencimiento">
          <DatePicker disabled format={DATE_FRONTEND_FORMAT} />
        </Form.Item>
      </Col>
    </Row>
    <Form.Item name="id" hidden>
      <Input disabled />
    </Form.Item>
  </Form>
);

export default FormCargo;
